<template>
  <section id="single-schedule">
    <dayone />
    <daytwo />
  </section>
</template>

<script>
import dayone from '@/components/dubai/2025/agenda/dayone.vue';
import daytwo from '@/components/dubai/2025/agenda/daytwo.vue';

export default {
  name: 'Agenda Dubai',
  components: {
    dayone,
    daytwo
  },
};
</script>

<style lang="scss" scoped>
  #single-schedule {
    padding: 20px 0 60px !important;
  }
</style>